import { Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputDate, Select } from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Form } from "../../layout";
import InputTime from "../../controls/InputTime";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import moment from "moment";
import { t } from "i18next";

const AddEditFollowUp = (props) => {
  const { setAlert, setShowForm, updData, inqData, setFollowUps } = props;
  const { FollowUpMdl } = Model();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const { branch, authUser } = useContext(AppContext);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
    handleInpDate,
  } = UseForm(FollowUpMdl);

  useEffect(() => {
    updData &&
      setValues((x) => ({
        ...x,
        ...updData,
        followUpTime: moment(updData.followUpTime, "HH:mm:ss"),
      }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  useEffect(() => {
    if (branch.id) {
      API(endpoints.FollowUpType + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res &&
            res.status === 200 &&
            setTypes([...res.result.map((j) => ({ id: j.id, label: j.name }))]);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const validateForm = () => {
    let temp = {};
    temp.followUpDate = values.followUpDate !== "" ? "" : t("ValFollowUpDate");
    temp.followUpTime = values.followUpTime !== "" ? "" : t("ValFollowUpTime");
    temp.followUpTypeId =
      values.followUpTypeId !== "" ? "" : t("ValFollowUpType");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() && inqData) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          if (setFollowUps && res.result.id) {
            updData
              ? setFollowUps((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setFollowUps((x) => [res.result, ...x]);
          }
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: `${t("FollowUp")} ${
              updData ? t("Update") : t("Added")
            } ${t("Successfully")}`,
          });
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        API(endpoints.FollowUp + actions.Post).post(
          ToFormData(
            RmvEmptyProp({
              ...values,
              branchId: branch.id,
              orgId: branch.orgId,
              addedUserId: authUser.id,
              inquiryId: inqData.id,
              followUpTime: new Date(values.followUpTime).toLocaleTimeString(),
            })
          ),
          onComplete
        );
      } else
        API(endpoints.FollowUp + actions.Put).put(
          ToFormData(
            RmvEmptyProp({
              ...values,
              followUpTime: new Date(values.followUpTime).toLocaleTimeString(),
            })
          ),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper
          className="p-15"
          sx={{ maxWidth: "450px", backgroundColor: "var(--aliceblue-color)" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} className="tx-center mb-30 pt-30 w-100pr">
              <p className="fs-24 mb-5 fw-4 tx-upp gray-color m-0 p-0">
                {updData ? t("Update") : t("Add")} {t("FollowUp")}
              </p>
              <div className="pos-relative d-flex j-center">
                <div className="border-bottom w-60" />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <InputDate
                label={t("FollowUpDate")}
                name="followUpDate"
                required={true}
                value={values.followUpDate}
                error={errors.followUpDate}
                minDate={new Date()}
                onChange={(date) =>
                  handleInpDate(
                    "followUpDate",
                    new Date(date).toLocaleDateString()
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputTime
                label={t("FollowUpTime")}
                name="followUpTime"
                required={true}
                value={values.followUpTime}
                error={errors.followUpTime}
                onChange={(date) =>
                  handleInpDate("followUpTime", new Date(date))
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                label={t("Type")}
                name="followUpTypeId"
                required={true}
                value={values.followUpTypeId}
                error={errors.followUpTypeId}
                onChange={handleInpChg}
                options={types}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("Note")}
                name="note"
                value={values.note}
                error={errors.note}
                onChange={handleInpChg}
                multiline
                inputProps={{ maxLength: 500 }}
                rows={2}
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="text"
                size="large"
                onClick={handleClose}
                fullWidth
              >
                {t("Cancel")}
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button loading={loading} size="large" type="submit" fullWidth>
                {t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditFollowUp;
